<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="promotionsLoading">
          <v-toolbar color="primary" dark>
            {{ pageSettings.title }}s
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon dark v-bind="attrs" v-on="on">mdi-information-variant</v-icon>
              </template>
              <p>
                ToolTip!
              </p>
            </v-tooltip>-->
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              prepend-icon="mdi-magnify"
              clearable
              v-on:input="onQuickFilterChanged()"
            ></v-text-field> -->
            <v-btn
              class="btn"
              @click="
                newPromotionDialog = true;
                newPDF = null;
                newPDFPreview = null;
              "
              outlined
              color="white"
            >
              <v-icon>mdi-plus</v-icon> New
            </v-btn>
          </v-toolbar>
          <!-- <expandedToolbar :newButton="true" @newButtonClick="newDeploymentDialog = true" /> -->
          <v-card-text v-if="promotions">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="3"
                v-for="promo in promotions"
                :key="promo.id"
                v-if="promo.isFeatured == isFeatured"
              >
                <v-card class="mx-auto">
                  <v-img
                    class="white--text align-end"
                    height="100px"
                    :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/PromotionImages/${promo.id}-Desktop.${promo.imageExtDesktop}?cb=${cb}`"
                  >
                    <v-chip
                      class="ma-2"
                      :color="promoStatusColor(promo.status)"
                      dark
                      label
                    >
                      {{ promo.status }}
                    </v-chip>
                  </v-img>

                  <v-card-subtitle class="pb-0">
                    {{ promo.name }}
                  </v-card-subtitle>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="editDetails(promo)" text color="primary">
                      Edit
                    </v-btn>

                    <v-btn
                      text
                      @click="switchStatus(promo)"
                      :color="promotionCardBtnColor(promo.status)"
                      :loading="switchStatusLoading == promo.id"
                    >
                      {{ promotionCardBtnText(promo.status) }}
                    </v-btn>
                    <v-btn
                      icon
                      @click="deletePromotion(promo.id)"
                      color="red"
                      :loading="promotionDeleteLoading == promo.id"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="newPromotionDialog">
      <v-card tile>
        <v-toolbar color="primary" dark>
          New {{ pageSettings.title }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="newPromotionDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container style="max-width: 1400px !important">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="newPromotion.name"
                  label="Promotion Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <h1>Desktop Banner</h1>
                <p>
                  We recommend an image size of
                  {{ this.pageSettings.desktopReccomendedSize }}(Landscape)
                </p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="newPromotion.actionType"
                  hint="What to happen when user clicks"
                  label="Click Action"
                  :items="actionTypes"
                  persistent-hint
                  single-line
                >
                </v-select>
              </v-col>
              <v-col
                v-if="newPromotion.actionType == 'SearchProduct'"
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="newPromotion.searchPhrase"
                  label="Search Phrase"
                  hint="To have search work for a specific product, use their SKU/Manufacturer marking"
                  persistent-hint
                >
                </v-text-field>
              </v-col>
              <v-col v-if="newPromotion.actionType == 'PDF'" cols="12" sm="6">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="application/pdf"
                  placeholder="Choose a PDF"
                  prepend-icon="mdi-file"
                  label="PDF"
                  v-model="newPDF"
                  @change="updateNewPreviewImage('PDF')"
                ></v-file-input>
              </v-col>
              <v-col v-if="newPromotion.actionType == 'URL'" cols="12" sm="6">
                <v-text-field
                  v-model="newPromotion.linkURL"
                  label="URL"
                  hint="The URL link to take a user when they click on this banner"
                  persistent-hint
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="Choose an Image"
                  prepend-icon="mdi-camera"
                  label="Image"
                  v-model="newDesktopImage"
                  @change="updateNewPreviewImage('Desktop')"
                ></v-file-input>
                <v-img
                  v-if="newDesktopImagePreview"
                  class="white--text align-end"
                  contain
                  width="100%"
                  style="border: 1px solid black"
                  :aspect-ratio="pageSettings.desktopAR"
                  :src="newDesktopImagePreview"
                ></v-img>
              </v-col>
              <v-col cols="12">
                <h1>Mobile Banner</h1>
                <p>
                  We recommend an image of
                  {{ this.pageSettings.mobileReccomendedSize }}(Portrait)
                </p>
              </v-col>

              <v-col cols="12">
                <v-card flat>
                  <v-file-input
                    :rules="imageUploadRules"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Choose an Image"
                    prepend-icon="mdi-camera"
                    label="Image"
                    v-model="newMobileImage"
                    @change="updateNewPreviewImage('Mobile')"
                  ></v-file-input>
                  <v-img
                    v-if="newMobileImagePreview"
                    class="white--text"
                    contain
                    style="margin: auto; border: 1px solid black"
                    height="300px"
                    width="250"
                    :aspect-ratio="pageSettings.mobileAR"
                    :src="newMobileImagePreview"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="primary"
            :loading="newPromotionLoading"
            @click="createNewPromotion()"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editPromotion" persistent max-width="90vw">
      <v-card tile>
        <v-toolbar color="primary" dark>
          {{ pageSettings.title }} #{{ selectedPromotion.id }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="editPromotion = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container style="max-width: 1400px !important">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="selectedPromotion.name"
                  label="Promotion Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="selectedPromotion.actionType"
                  hint="What to happen when user clicks"
                  label="Click Action"
                  :items="actionTypes"
                  persistent-hint
                  single-line
                >
                </v-select>
              </v-col>
              <v-col
                v-if="selectedPromotion.actionType == 'SearchProduct'"
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="selectedPromotion.searchPhrase"
                  label="Search Phrase"
                  hint="To have search work for a specific product, use their SKU/Manufacturer marking"
                  persistent-hint
                >
                </v-text-field>
              </v-col>
              <v-col
                v-if="selectedPromotion.actionType == 'PDF'"
                cols="12"
                sm="6"
              >
                <v-file-input
                  :rules="imageUploadRules"
                  accept="application/pdf"
                  placeholder="Choose a PDF"
                  prepend-icon="mdi-file"
                  label="PDF"
                  v-model="newPDF"
                  @change="updateNewPreviewImage('PDF')"
                ></v-file-input>
              </v-col>
              <v-col
                v-if="selectedPromotion.actionType == 'URL'"
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="selectedPromotion.linkURL"
                  label="URL"
                  hint="The URL link to take a user when they click on this banner"
                  persistent-hint
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <h1>Desktop Banner</h1>
              </v-col>
              <v-col cols="12">
                <v-card flat>
                  <v-img
                    class="white--text align-end"
                    width="100%"
                    :aspect-ratio="pageSettings.desktopAR"
                    :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/PromotionImages/${selectedPromotion.id}-Desktop.${selectedPromotion.imageExtDesktop}?cb=${cb}`"
                  >
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12">
                <h1>Mobile Banner</h1>
              </v-col>
              <v-col cols="12">
                <v-card flat>
                  <v-img
                    class="white--text"
                    style="margin: auto"
                    height="300px"
                    width="250"
                    :aspect-ratio="pageSettings.mobileAR"
                    :src="`https://telfers-frontend.s3-ap-southeast-2.amazonaws.com/PromotionImages/${selectedPromotion.id}-Mobile.${selectedPromotion.imageExtMobile}?cb=${cb}`"
                  >
                  </v-img>
                </v-card>
              </v-col>

              <v-col cols="12" sm="6" style="text-align: center">
                <v-btn @click="changeDesktopImage()" block dark color="primary">
                  Change Desktop Image
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" style="text-align: center">
                <v-btn @click="changeMobileImage()" block dark color="primary">
                  Change Mobile Image
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            @click="savePromotion()"
            color="success"
            :loading="promotionSaveLoading"
          >
            Save Promotion
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadImageDialog" persistent max-width="600px">
      <v-card tile>
        <v-toolbar color="primary" dark>
          Upload an Image for {{ imagePreviewSettings }}
          <v-spacer></v-spacer>
          <v-btn color="white" icon dark @click="uploadImageDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col v-if="imagePreviewSettings != null" cols="12">
                <v-file-input
                  :rules="imageUploadRules"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="Choose an Image"
                  prepend-icon="mdi-camera"
                  label="Image"
                  v-model="image"
                  @change="updatePreviewImage"
                ></v-file-input>
                <p v-if="imagePreviewSettings == 'Desktop'">
                  We recommend an image size of
                  {{ this.pageSettings.desktopReccomendedSize }}(Landscape)
                </p>
                <p v-else>
                  We recommend an image of
                  {{ this.pageSettings.mobileReccomendedSize }}(Portrait)
                </p>
              </v-col>
              <v-col v-if="previewUrl != null" cols="12">
                <!-- Desktop Preview -->
                <v-img
                  v-if="imagePreviewSettings == 'Desktop'"
                  class="white--text align-end"
                  contain
                  width="100%"
                  style="border: 1px solid black"
                  :aspect-ratio="pageSettings.desktopAR"
                  :src="previewUrl"
                ></v-img>
                <v-img
                  v-else
                  class="white--text"
                  contain
                  style="margin: auto; border: 1px solid black"
                  height="300px"
                  width="250"
                  :aspect-ratio="pageSettings.mobileAR"
                  :src="previewUrl"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="btn"
            color="success"
            :loading="imageUploadLoading"
            @click="uploadImage()"
            >Upload Image</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import expandedToolbar from "@/components/expandedToolbar.vue";
  import moment from "moment";

  export default {
    components: { AppBar, expandedToolbar },
    computed: {
      ...mapGetters([
        "currentUser",
        "currentUserData",
        "promotions",
        "promotionsLoading",
      ]),
    },
    props: {
      source: String,
    },
    data: () => ({
      isFeatured: false,
      pageSettings: {},
      // Image Upload
      uploadImageDialog: false,
      imageUploadRules: [
        (value) =>
          !value ||
          value.size < 40000000 ||
          "Avatar size should be less than 40 MB!",
      ],
      image: null,
      previewUrl: null,
      imageUploadLoading: false,
      search: "",
      editPromotion: false,
      switchStatusLoading: null,
      selectedPromotion: {},
      tab: null,
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      imagePreviewSettings: null,
      cb: null,

      // New promotion
      newPromotionDialog: false,
      newPromotion: {},
      newDesktopImage: null,
      newMobileImage: null,
      newDesktopImagePreview: false,
      newMobileImagePreview: false,
      newPromotionLoading: false,
      actionTypes: ["Disabled", "SearchProduct", "PDF", "URL"],

      // Save promotion
      promotionSaveLoading: false,

      // deleting promotion
      promotionDeleteLoading: null,

      newPDF: null,
      newPDFPreview: false,
    }),
    watch: {
      $route: function (oldRoute, newRoute) {
        if (this.$route.params.type == "featured") {
          this.isFeatured = true;
          this.pageSettings = {
            title: "Featured Slide",
            desktopAR: 14 / 5,
            desktopReccomendedSize: "1400x500",
            mobileAR: 6 / 5,
            mobileReccomendedSize: "400x330",
          };
        } else {
          this.isFeatured = false;
          this.pageSettings = {
            title: "Promotion",
            desktopAR: 14 / 3,
            desktopReccomendedSize: "1400x300",
            mobileAR: 6 / 5,
            mobileReccomendedSize: "400x330",
          };
        }
      },
    },
    mounted() {
      // this.columnDefs = [

      //   {
      //     headerName: "ID",
      //     field: "id",
      //   },
      // ];
      this.$store.dispatch("loadPromotions");
      if (this.$route.params.type == "featured") {
        this.isFeatured = true;
        this.pageSettings = {
          title: "Featured Slide",
          desktopAR: 14 / 5,
          desktopReccomendedSize: "1400x500",
          mobileAR: 6 / 5,
          mobileReccomendedSize: "600x500",
        };
      } else {
        this.isFeatured = false;
        this.pageSettings = {
          title: "Promotion",
          desktopAR: 14 / 3,
          desktopReccomendedSize: "1400x300",
          mobileAR: 6 / 5,
          mobileReccomendedSize: "600x500",
        };
      }
      this.cb = this.r();
    },
    methods: {
      promoStatusColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "red";
            break;
          case "Active":
            color = "green";
            break;
          default:
            break;
        }
        return color;
      },
      promotionCardBtnColor(status) {
        let color = "grey";
        switch (status) {
          case "In-Active":
            color = "green";
            break;
          case "Active":
            color = "red";
            break;
          default:
            break;
        }
        return color;
      },
      promotionCardBtnText(status) {
        let text = "grey";
        switch (status) {
          case "In-Active":
            text = "Make Active";
            break;
          case "Active":
            text = "Make In-Active";
            break;
          default:
            break;
        }
        return text;
      },
      switchStatus(promo) {
        this.switchStatusLoading = promo.id;
        if (promo.status != "Active") {
          promo.status = "Active";
        } else {
          promo.status = "In-Active";
        }
        this.$store.dispatch("savePromotion", promo).then((result) => {
          this.switchStatusLoading = false;
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Promotion has been Updated",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      editDetails(promo) {
        this.selectedPromotion = promo;
        this.newPDFPreview = null;
        this.newPDF = null;
        this.editPromotion = true;
      },
      changeDesktopImage() {
        this.imagePreviewSettings = "Desktop";
        this.uploadImageDialog = true;
      },
      changeMobileImage() {
        this.imagePreviewSettings = "Mobile";
        this.uploadImageDialog = true;
      },
      uploadImage() {
        this.imageUploadLoading = true;
        const payload = {
          id: this.selectedPromotion.id,
          screenSize: this.imagePreviewSettings,
          data: this.previewUrl,
        };
        this.$store.dispatch("promotionsUploadImage", payload).then((result) => {
          if (result.Result == "Success") {
            this.$swal({
              title: "Success!",
              text: "Image has been Uploaded",
              type: "success",
              confirmButtonText: "Ok",
            });
            let ext = this.previewUrl.match(/.*image\/(.*);/);
            if (this.imagePreviewSettings == "Desktop") {
              this.selectedPromotion.imageExtDesktop = ext[1];
            } else {
              this.selectedPromotion.imageExtMobile = ext[1];
            }
            this.imagePreviewSettings = null;
            this.imageUploadLoading = false;
            this.uploadImageDialog = false;
            this.cb = this.r();
          } else {
            this.$swal({
              title: "Error",
              text: "Please try again Later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      updatePreviewImage() {
        if (this.image != undefined) {
          var reader = new FileReader();
          reader.readAsDataURL(this.image);
          reader.onload = () => {
            this.previewUrl = reader.result;
          };
        } else {
          this.previewUrl = null;
        }
      },
      updateNewPreviewImage(caller) {
        var reader = new FileReader();
        if (caller == "Desktop") {
          if (this.newDesktopImage != undefined) {
            reader.readAsDataURL(this.newDesktopImage);
            reader.onload = () => {
              this.newDesktopImagePreview = reader.result;
            };
          } else {
            this.newDesktopImagePreview = false;
          }
        } else if (caller == "Mobile") {
          if (this.newMobileImage != undefined) {
            reader.readAsDataURL(this.newMobileImage);
            reader.onload = () => {
              this.newMobileImagePreview = reader.result;
            };
          } else {
            this.newMobileImagePreview = false;
          }
        } else if (caller == "PDF") {
          if (this.newPDF != undefined) {
            reader.readAsDataURL(this.newPDF);
            reader.onload = () => {
              this.newPDFPreview = reader.result;
            };
          } else {
            this.newPDFPreview = false;
          }
        }
      },
      savePromotion() {
        let payload = {
          actionType: this.selectedPromotion.actionType,
          searchPhrase: this.selectedPromotion.searchPhrase,
          linkUrl: this.selectedPromotion.linkURL,
          name: this.selectedPromotion.name,
          id: this.selectedPromotion.id,
        };
        console.log(payload);
        this.promotionSaveLoading = true;
        this.$store.dispatch("savePromotion", payload).then((result) => {
          if (result.Result == "Success") {
            this.promotionSaveLoading = false;
            this.editPromotion = false;
            this.uploadPDF(this.selectedPromotion.id);
            this.$swal({
              title: "Success",
              text: "The promotion has been saved",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.promotionSaveLoading = false;
            this.$swal({
              title: "Error",
              text: "Please try again later",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
      createNewPromotion() {
        this.newPromotionLoading = true;
        if (
          this.newMobileImagePreview != false &&
          this.newDesktopImagePreview != false
        ) {
          this.newPromotion.isFeatured = this.isFeatured ? 1 : 0;
          this.$store
            .dispatch("newPromotion", this.newPromotion)
            .then((result) => {
              if (result.Result == "Success") {
                let payload = {
                  id: result.id,
                  screenSize: "Desktop",
                  data: this.newDesktopImagePreview,
                };
                this.$store
                  .dispatch("promotionsUploadImage", payload)
                  .then((desktopImageResult) => {
                    if (desktopImageResult.Result == "Success") {
                      let payload = {
                        id: result.id,
                        screenSize: "Mobile",
                        data: this.newMobileImagePreview,
                      };
                      this.$store
                        .dispatch("promotionsUploadImage", payload)
                        .then((mobileImageResult) => {
                          if (mobileImageResult.Result == "Success") {
                            this.newPromotionDialog = false;
                            this.newPromotion = {};
                            this.newDesktopImage = null;
                            this.newMobileImage = null;
                            this.newDesktopImagePreview = false;
                            this.newMobileImagePreview = false;
                            this.newPromotionLoading = false;
                            this.$store.dispatch("loadPromotions");
                            this.$swal({
                              title: "Success",
                              text: "The promotion has been created",
                              type: "success",
                              confirmButtonText: "Ok",
                            });
                          } else {
                            this.newPromotionLoading = false;
                            this.$swal({
                              title: "Error",
                              text: "There was an issue Uploading the Mobile Image",
                              type: "error",
                              confirmButtonText: "Ok",
                            });
                          }
                        });
                    } else {
                      this.newPromotionLoading = false;
                      this.$swal({
                        title: "Error",
                        text: "There was an issue Uploading the Desktop Image",
                        type: "error",
                        confirmButtonText: "Ok",
                      });
                    }
                  });
                this.uploadPDF(result.id);
              } else {
                this.newPromotionLoading = false;
                this.$swal({
                  title: "Error!",
                  text: "Something went wrong, please try again later",
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            });
        } else {
          this.newPromotionLoading = false;
          this.$swal({
            title: "Whoops!",
            text: "Please upload a Desktop and Mobile banner before continuing",
            type: "warning",
            confirmButtonText: "Ok",
          });
        }
      },
      r() {
        return Math.random().toString(36).substring(7);
      },
      deletePromotion(id) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete a Promotion, Are you sure you want to continue?",
          type: "warning",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then((res) => {
          if (res.value) {
            let payload = {
              id: id,
            };
            this.promotionDeleteLoading = id;
            this.$store.dispatch("deletePromotion", payload).then((result) => {
              if (result.Result == "Success") {
                this.promotionDeleteLoading = null;
                this.$swal({
                  title: "Success",
                  text: "The promotion has been deleted",
                  type: "success",
                  confirmButtonText: "Ok",
                });
              } else {
                this.promotionDeleteLoading = null;
                this.$swal({
                  title: "Error",
                  text: "Please try again later",
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            });
          }
        });
      },
      uploadPDF(id) {
        if (!this.newPDFPreview) return;
        let payload = {
          type: "PDF",
          id: id,
          data: this.newPDFPreview,
        };

        this.$store.dispatch("promotionsUpload", payload).then((result) => {
          this.newPDFPreview = null;
          if (result.Result == "Success") {
            this.$swal({
              title: "Success",
              text: "The pdf has been created",
              type: "success",
              confirmButtonText: "Ok",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "Something went wrong, the PDF was not uploaded",
              type: "error",
              confirmButtonText: "Ok",
            });
          }
        });
      },
    },
  };
</script>
